<div #iframe class="iframe-container"></div>
<!--<button mat-icon-button-->
<!--        mat-mdc-icon-micro-button-->
<!--        (click)="close()"-->
<!--        class="close"-->
<!--        tabindex="-1">-->
<!--  <mat-icon>close</mat-icon>-->
<!--</button>-->
